export const environment = {
    disableConsoleOutput: false
};

/* eslint-disable no-console */
export class ConsoleFacade  {

    public static assert(value: any, message?: string, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.log(value, message, optionalParams);

    }

    public static dir(obj: any, options?: any): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.dir(obj, options);

    }

    public static error(message?: any, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.error(message, optionalParams);

    }

    public static info(message?: any, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.info(message, optionalParams);

    }

    public static log(message?: any, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.log(message, optionalParams);
    }

    public static time(label: string): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.time(label);
    }

    public static timeEnd(label: string): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.timeEnd(label);

    }

    public static trace(message?: any, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.trace(message, optionalParams);

    }

    public static warn(message?: any, ...optionalParams: any[]): void {

        if (environment.disableConsoleOutput) {
            return;
        }

        console.warn(message, optionalParams);
    }
}
/* eslint-enable no-console */
